export default __webpack_public_path__ + "static/media/trophy.023b9a4e.svg";